"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var string_format_1 = tslib_1.__importDefault(require("string-format"));
var Url_1 = require("./Url");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var AlarmTypes = /** @class */ (function () {
    function AlarmTypes() {
    }
    AlarmTypes.prototype.getAlarmProperties = function (modelId, alarmId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetAlarmProperties, modelId, alarmId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    AlarmTypes.prototype.getAlarms = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetAlarms, modelId);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    AlarmTypes.prototype.getEventProperties = function (modelId, eventId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetEventProperties, modelId, eventId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    AlarmTypes.prototype.getEvents = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetEvents, modelId);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    return AlarmTypes;
}());
exports.AlarmTypes = AlarmTypes;
//# sourceMappingURL=AlarmTypes.js.map